import { BankAccount } from '@40seas/entities/bank-account';
import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { BaseEntity, Currency, Fee, FeeSchema, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { BankAccountSchema } from './../../../bank-account/src/lib/bank-account.entity';
import { ChargeTransactionPayload } from './charge-transaction.payload.entity';
import { CurrencyConversionTransactionPayload } from './currency-conversion-transaction.payload.entity';
import { DepositTransactionPayload } from './deposit-transaction.payload.entity';
import { TransactionPayloadSchema } from './transaction.payload.schema';
import { TransactionStatus } from './transaction.status.enum';
import { WithdrawalTransactionPayload } from './withdrawal-transaction.payload.entity';

export enum TransactionMode {
    Manual = 'manual',
    Automatic = 'automatic',
    Log = 'log',
}

export enum TransactionType {
    Withdrawal = 'withdrawal',
    Deposit = 'deposit',
    CurrencyConversion = 'currency-conversion',
    Charge = 'charge',
    Payment = 'payment',
}

export enum TransactionProviderType {
    Svb = 'svb',
    Wise = 'wise',
    Airwallex = 'airwallex',
}

export enum TransactionEntityType {
    Payout = 'payout',
    CurrencyConversion = 'currencyconversion',
    Billing = 'billing',
}

export const TransactionSchema = WithBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore - Fix TS FS-3199
        transactionTime: ZodDate,
        mode: EnumSchema(TransactionMode),
        type: EnumSchema(TransactionType),
        status: EnumSchema(TransactionStatus),
        entityType: EnumSchema(TransactionEntityType).optional(),
        entitiesIds: z.array(z.string()).nullish(),
        providerType: EnumSchema(TransactionProviderType).optional().openapi({ ref: 'transactionProviderTypeEnum' }),
        providerId: z.string().optional(),
        bankAccount: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            .or(BankAccountSchema)
            .optional(),
        reference: z.string().optional(),
        currency: EnumSchema(Currency),
        amount: z.number(),
        netAmount: z.number().optional(),
        balance: z.number().optional(),
        payload: TransactionPayloadSchema.optional(),
        fees: z.array(FeeSchema).optional(),
    }),
).strict();

export class Transaction extends FromSchema(TransactionSchema) implements BaseEntity {
    id: string;
    transactionTime: Date;
    type: TransactionType;
    mode: TransactionMode;
    status: TransactionStatus;
    entityType?: TransactionEntityType;
    entitiesIds?: string[];
    providerType?: TransactionProviderType;
    providerId?: string;
    bankAccount?: string | BankAccount;
    reference?: string;
    amount: number;
    currency: Currency;
    netAmount?: number;
    balance?: number;
    payload?: DepositTransactionPayload | WithdrawalTransactionPayload | CurrencyConversionTransactionPayload | ChargeTransactionPayload;
    fees?: Fee[];
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
